<template>
  <div id="dialog" class="common-dialog-ctn">
    <transition name="popup">
      <div class="confirm-dialog" v-show="show && mode == 'confirm'">
        <div class="dialog-header">
          <template v-if="confirmData.icon == 'error'">
            <img src="../../../assets/icon-dialog-error.png" alt />
          </template>
          <template v-if="confirmData.icon == 'warn'">
            <img src="../../../assets/icon-dialog-warn.png" alt />
          </template>
          <template v-if="confirmData.icon == 'success'">
            <img src="../../../assets/icon-dialog-success.png" alt />
          </template>
        </div>
        <div class="dialog-body">
          <div class="dialog-msg">{{confirmData.title}}</div>
          <div class="dialog-msg-sub">{{confirmData.content}}</div>
        </div>

        <!-- 兑换赠送碎片 -->
        <a href="javascript:;" @click="gotoPresent"  v-if="present">
          <div class="dialog-action present-item">
            <span class="icon-wallet"></span>
            <span class="text">获得<span style="color: #ff0000">{{present}}片</span>碎片，去看看</span>
            <span class="icon-arrow-right"></span>
          </div>
        </a>

        <div class="actions">
          <button
            @click="doConfirmAction(confirmData.actions.defaultBtn)"
            v-if="confirmData.actions.defaultBtn"
          >{{confirmData.actions.defaultBtn}}</button>
          <button
            class="primary"
            @click="doConfirmAction(confirmData.actions.primaryBtn)"
            v-if="confirmData.actions.primaryBtn"
          >{{confirmData.actions.primaryBtn }}</button>
        </div>
      </div>
    </transition>
    
    <transition name="popup">
    <div class="alert-dialog" v-show="show && mode == 'alert'">
      <div class="dialog-header">
        <template v-if="alertData.icon == 'error'">
          <img src="../../../assets/icon-dialog-error.png" alt />
        </template>
        <template v-if="alertData.icon == 'warn'">
          <img src="../../../assets/icon-dialog-warn.png" alt />
        </template>
        <template v-if="alertData.icon == 'success'">
          <img src="../../../assets/icon-dialog-success.png" alt />
        </template>
      </div>
      <div class="dialog-body">
        <div class="dialog-msg">{{alertData.title}}</div>
        <div class="dialog-msg-sub">{{alertData.content}}</div>
      </div>
      <div class="actions">
        <button
          @click="doAlertAction(alertData.actions.primaryBtn)"
        >{{alertData.actions.primaryBtn}}</button>
      </div>
    </div>
    </transition>

    <transition name="popup">
      <div class="agreement-dialog" v-show="show && mode == 'agreement'">
        <a href="javascript:;" class="close-btn" @click="closeAgreementDialog"></a>
        <div class="dialog-header">{{agreementData.title}}</div>
        <div class="dialog-body" v-html="agreementData.content"></div>
        <div class="actions">
          <button
            @click="doAgreementAction(agreementData.actions.primaryBtn)"
          >{{agreementData.actions.primaryBtn}}</button>
        </div>
      </div>
    </transition>

    <div class="mask" v-if="show"></div>
  </div>
</template>



<script>
import store from "../../../api/store";

export default {
  data() {
    return {
      present: '',
      show: false, //是否显示
      mode: "", //confirm, alert, agreement
      confirmData: {
        icon: "warn",
        title: "标题",
        content: "确认保存？",
        actions: {
          defaultBtn: "不是",
          primaryBtn: "是的"
        }
      },
      alertData: {
        icon: "warn",
        title: "",
        content: "",
        actions: {
          primaryBtn: "我知道了"
        }
      },
      agreementData: {
        title: "使用协议",
        content: "",
        actions: {
          primaryBtn: "我同意以上协议"
        }
      }
    };
  },
  watch: {
    show(val){
      if(val){ //reload when it show
        this.reload();
      }
    }
  },
  methods: {
    gotoPresent() {
      var url = process.env.lotteryLoginUrl;
      location.href = `${url}` ;
    },
    reload(){
      console.log(store)
      this.present = store.present;
    },
    confirm: function(opts) {
      this.show = true;
      this.mode = "confirm";
      this.confirmData.icon = opts.icon || "warn";
      this.confirmData.title = opts.title;
      this.confirmData.content = opts.content;
      this.confirmData.actions.defaultBtn = opts.btns[0];
      this.confirmData.actions.primaryBtn = opts.btns[1];
      this.opts = opts;
    },
    doConfirmAction: function(btn) {
      this.show = false;
      this.mode = "";
      if (this.opts && this.opts.callback) {
        this.opts.callback(btn);
      }
      this.opts = null;
    },
    alert: function(opts) {
      this.show = true;
      this.mode = "alert";
      this.alertData.icon = opts.icon || "warn";
      this.alertData.title = opts.title;
      this.alertData.content = opts.content;
      this.alertData.actions.primaryBtn = opts.btn;
      this.opts = opts;
    },
    doAlertAction: function(btn) {
      this.show = false;
      this.mode = "";
      if (this.opts && this.opts.callback) {
        this.opts.callback(btn);
      }
      this.opts = null;
    },
    agreement: function(opts) {
      this.show = true;
      this.mode = "agreement";
      this.agreementData.title = opts.title || this.agreementData.title;
      this.agreementData.content = opts.content || this.agreementData.content;
      this.agreementData.actions.primaryBtn =
        opts.btn || this.agreementData.actions.primaryBtn;
      this.opts = opts;
      ModalHelper.afterOpen();
    },
    doAgreementAction: function(btn) {
      this.show = false;
      this.mode = "";
      if (this.opts && this.opts.callback) {
        this.opts.callback(btn);
      }
      this.opts = null;
      ModalHelper.beforeClose();
    },
    closeAgreementDialog: function() {
      this.show = false;
      this.mode = "";
      this.opts = null;
      ModalHelper.beforeClose();
    }
  }
};
</script>

<style lang="less" scoped>

.common-dialog-ctn .mask {
  z-index: 998;
  opacity: 0.2;
  background: #000;
}

/*confirm-dialog*/

.confirm-dialog {
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  background: #fff;
  border-radius: 2vw;
  width: 74.6vw;
  margin-left: -37.3vw;
  margin-top: -32vw;
  overflow: hidden;
}

.confirm-dialog .dialog-header {
  padding-top: 4.8vw;
  text-align: center;
}

.confirm-dialog .dialog-header img {
  height: 10vw;
}

.confirm-dialog .dialog-body {
  font-size: 4.8vw;
  color: #333;
  text-align: center;
  line-height: 2em;
  padding-left: 3vw;
  padding-right: 3vw;
}

.confirm-dialog .dialog-body .dialog-msg-sub {
  font-size: 3.8vw;
  color: #9b9b9b;
}

.confirm-dialog .actions {
  border-top: 0.3vw solid #eee;
  font-size: 0;
  position: static;
  box-shadow: none;
}

.confirm-dialog .actions button {
  background: #fff;
  height: 13.33vw;
  border: none;
  text-align: center;
  width: 50%;
  font-size: 4.8vw;
  color: #9b9b9b;
}

.confirm-dialog .actions button:first-child {
  border-right: 0.2vw solid #eee;
}

.confirm-dialog .actions button.primary {
  background: #fe3233;
  color: white;
}

/*alert-dialog*/

.alert-dialog {
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  background: #fff;
  border-radius: 2vw;
  width: 74.6vw;
  margin-left: -37.3vw;
  margin-top: -32vw;
  overflow: hidden;
}

.alert-dialog .dialog-header {
  padding-top: 4.8vw;
  text-align: center;
}

.alert-dialog .dialog-header img {
  height: 10vw;
}

.alert-dialog .dialog-body {
  font-size: 4.8vw;
  color: #333;
  text-align: center;
  line-height: 2em;
  padding-left: 3vw;
  padding-right: 3vw;
}

.alert-dialog .dialog-body .dialog-msg-sub {
  font-size: 3.8vw;
  color: #9b9b9b;
}

.alert-dialog .actions {
  border-top: 0.3vw solid #eee;
  font-size: 0;
  position: static;
  box-shadow: none;
}

.alert-dialog .actions button {
  background: #fff;
  height: 13.33vw;
  border: none;
  text-align: center;
  width: 100%;
  font-size: 4.8vw;
  color: #09ba70;
}

/*agreement-dialog*/

.agreement-dialog {
  position: fixed;
  z-index: 999;
  top: 10vw;
  left: 50%;
  background: #fff;
  border-radius: 2vw;
  width: 74.6vw;
  margin-left: -37.3vw;
  overflow: hidden;
}

.agreement-dialog .close-btn {
  display: inline-block;
  background-image: url(../../../assets/icon-dialog-close.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 3.46vw;
  height: 3.46vw;
  position: absolute;
  top: 3.46vw;
  right: 3.46vw;
}

.agreement-dialog .dialog-header {
  padding-top: 4.8vw;
  text-align: center;
  border-bottom: 0.3vw solid #eee;
  font-size: 4.8vw;
}

.agreement-dialog .dialog-body {
  font-size: 3.2vw;
  color: #333;
  text-align: left;
  line-height: 2em;
  padding-left: 3vw;
  padding-right: 3vw;
  background: #f5f5f5;
  max-height: 100vw;
  overflow-y: auto;
  overflow-x: hidden;
}

.agreement-dialog .dialog-body h1,
.agreement-dialog .dialog-body h2,
.agreement-dialog .dialog-body h3 {
  font-size: 3.2vw;
  margin-top: 0;
  margin-bottom: 0;
}

.agreement-dialog .actions {
  border-top: 0.3vw solid #eee;
  font-size: 0;
  position: static;
  box-shadow: none;
}

.agreement-dialog .actions button {
  background: #fff;
  height: 13.33vw;
  border: none;
  text-align: center;
  width: 100%;
  font-size: 4.8vw;
  color: #09ba70;
}

.dialog-action {
  margin-top: 5.066vw;
  border-top: 0.2vw solid #eee;
  position: relative;
  height: 13.33vw;


  .icon-wallet {
    display: inline-block;
    background-image: url(//res.uuudian.com/hk_data/2b511614-390f-4fd2-9756-73dc5a0a2655);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 6.666vw;
    height: 6.666vw;
    position: absolute;
    left: 1vw;
    top: 50%;
    margin-top: -3.333vw;
  }

  .text {
    position: absolute;
    left: 8.266vw;
    top: 50%;
    margin-top: -2.3vw;
    font-size: 4vw;
    color: #81838e;
  }

  .icon-arrow-right {
    display: inline-block;
    background-image: url(//res.uuudian.com/hk_data/2bb8f508-dde3-4e68-8187-0f0506b03d6d);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 4vw;
    height: 4vw;
    position: absolute;
    right: 0vw;
    top: 50%;
    margin-top: -1.7vw;
    opacity: 0.8;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/global/dialog/dialog.vue